import {Component, EventEmitter, Input, OnInit, Output,} from '@angular/core';
import {TreeNode} from "primeng/api";
import {LocalService} from "../../../../services/LocalService";
import LocalDataSource from "../../../../data-sources/LocalDataSource";
import {Local} from "../../../../domain/Local";
import {FaunaDataSource} from "../../../../services/persist/FaunaDataSource";
import {IRepository} from "../../../../services/persist/IRepository";
import {IsNull, Not} from "typeorm";

@Component({
  selector: 'app-selecao-local',
  templateUrl: './selecao-local.component.html',
  styleUrls: ['./selecao-local.component.scss'],
})
export class SelecaoLocalComponent implements OnInit{
  isLocalOpen = false;
  nos: TreeNode[] = []
  selecao!: any
  localService = new LocalService()
  _local?: Local
  repo: IRepository<Local>

  constructor(ds: FaunaDataSource) {
    this.repo = ds.getRepository(Local)
  }

  @Input() set local(value: Local|undefined) {
    this._local = value;
    this.selecao = value ? this.localService.getNos([value], false)[0] : undefined
  }

  get local(): Local|undefined {
    return this._local;
  }

  @Output()
  localChange = new EventEmitter<Local>();

  ngOnInit() {
    this.montaNos().then()
  }

  async montaNos(){
    const trees = await this.repo.find({
      relations: ["biomas", "locais.locais.locais.locais.locais.locais.locais"],
      where: {pai: IsNull(), excluido: Not(true)}
    })
    this.nos = this.localService.getNos(trees, false, true)
  }

  voltar(){
    this.isLocalOpen = false
  }

  close(){
    this.isLocalOpen = false
    this.local = (this.selecao as TreeNode)?.data
    this.localChange.emit(this.local)
  }
  open() {
    this.isLocalOpen = true;
  }
}
